<template>
  <div class="prescription">
    <BarCode :barList="barList"></BarCode>
    <img v-if="list.prescriptionImage" :src="insuranceImage" alt />
  </div>
</template>
<script>
import { parseTime,getInsuranceImage } from '../../utils/index'
import BarCode from '../waitpre/barcode.vue'
export default {
  components: {BarCode},
  props: {
    list: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      // list: {},
      NOW_TIME: '',
      // 药师签名
      pharmacistSignUrl: '',
      // 医师签名
      physicianSignUrl: '',
      // 处方照片
      insuranceImage: getInsuranceImage(this.list.prescriptionImage),
    }
  },
  watch: {
    list(res) {
      this.list = res
      this.pharmacistSignUrl = res.pharmacistSign // 药师签名
      this.physicianSignUrl = res.physicianSign // 医师签名
      console.log(this.list,'sasas');
      
    }
  },
  computed: {
    barList(){
      const list = []
      list.push({
        label: "处方编号",
        value: this.list.pref
      })
      list.push({
        label: "医师编码",
        value: this.list.medicareCode
      })
      list.push({
        label: "医疗机构编码",
        value: this.list.medicalInstitutionCode
      })
      console.log(this.list,'this.list');
      return list
    }
  }
}
</script>
<style scoped lang="scss">
/* 整体圆角 */
.prescription {
  border-radius: 0 0 14px 14px;
  background: #ffffff;
  margin: 0 15px;
  img {
    width: 100%;
  }
}
/* 调整头部 */
.presTitle {
  width: 345px;
  height: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.presTitle p {
  line-height: 25px;
  margin: 0;
  font-size: 18px;
  font-weight: 550;
  color: #333;
}

/* 调整ul */
.Personaldetail {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  width: 335px;
  padding: 0 15px 8px 15px;
  box-sizing: border-box;
  border-bottom: 1px solid #e1e1e1;
}
.Personaldetail li {
  line-height: 28px;
  color: #333;
  font-weight: 400;
  margin-bottom: 5px;
}

.Personaldetail li:not(:last-child) {
  display: flex;
  justify-content: space-between;
}
.Personaldetail li span:nth-of-type(1) {
  width: 100%;
}
.Personaldetail li span:nth-of-type(2) {
  width: 169px;
}
/* 调整brP */
.brP {
  width: 335px;
  margin: 8px 0;
  padding-left: 10px;
  box-sizing: border-box;
}
/* 调整药品 */
.tablelist {
  width: 335px;
  padding: 0 5px 10px 5px;
  box-sizing: border-box;
}
.tableli {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-bottom: 7px;
  display: flex;
  word-break: break-all;
  padding-left: 10px;
  box-sizing: border-box;
}
.tableli span:nth-of-type(1) {
  width: 140px;
  display: inline-block;
  margin-right: 7px;
}
.tableli span:nth-of-type(2) {
  width: 178px;
  display: inline-block;
}
.tableli span:nth-of-type(2) span:not(:last-child) {
  margin-bottom: 5px;
}
/* 签名 */
.prebottom {
  width: 325px;
  padding: 10px 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e1e1e1;
}
.prebottom p {
  margin: 0;
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 400;
  color: #333;
}
.prebottom img {
  width: 45px;
  height: 30px;
  vertical-align: middle;
}
.prebottom p span:nth-of-type(1) {
  margin-right: 5px;
}
</style>
